import { type Maybe, useRegle } from '@regle/core'
import { required, withMessage } from '@regle/rules'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { normalizeNumber } from '@/shared/lib/formatting'

import { getUserData, type UserData } from '../api'

export const useModel = defineStore('user-data', () => {
    const isFetchingData = ref(false)

    const { r$ } = useRegle(
        {
            phone: '',
        },
        {
            phone: {
                phoneFormat: withMessage((value: Maybe<string>) => {
                    const clean = normalizeNumber(value || '')
                    return { $valid: clean.length === 11 }
                }, 'Введите номер телефона полностью'),
                required: withMessage(required, 'Поле обязательно'),
            },
        },
        {
            autoDirty: false,
        }
    )

    const userData = ref<null | UserData>(null)

    async function fetchUserData() {
        isFetchingData.value = true

        try {
            const response = await getUserData()

            isFetchingData.value = false

            if (!response || !('phone' in response)) return false
            userData.value = response

            return true
        } catch {
            isFetchingData.value = false
            return false
        }
    }

    function setUserData(data: UserData) {
        userData.value = data
    }

    return {
        fetchUserData,
        isFetchingData,
        r$,
        setUserData,
        userData,
    }
})
